import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardWithTitle = _resolveComponent("CardWithTitle")!

  return (_openBlock(), _createBlock(_component_CardWithTitle, {
    title: _ctx.detail.title,
    class: "sm:w-6/12 text-center mb-2"
  }, {
    default: _withCtx(() => [
      (_ctx.detail.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "description-text w-full text-left gray-700 whitespace-pre-wrap px-4 break-words",
            innerHTML: _ctx.detail.description
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      (_ctx.detail.image_path)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.detail.image_path,
            class: "m-auto"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}